import React, { useState } from 'react';
import { Check, Shield, Lock, Download, CreditCard, HeadphonesIcon, Star, Crown, PlayCircle } from 'lucide-react';
import { CountdownTimer } from './CountdownTimer';
const CHECKOUT_BASE = 'https://elrincondigital.click/checkouts/cn/hWNAzaPwalqJbEBkJzoRb77i/es-ar?_r=AQABbAjs0DzDdFIIbrt4qklW5wXh1DsjTniDg14oVlNZ2AE&preview_theme_id=154785841310';
const CHECKOUT_MEGA = 'https://elrincondigital.click/checkouts/cn/hWNAzeY6coQLFnynazooanPm/es-ar?_r=AQAB5TVdkxvfT0I2DN2bqQ1mvLwU0R3Li7jiifzu7BCpAHM&preview_theme_id=154785841310';
interface OfferSectionProps {
  onCheckout: () => void;
}
export function OfferSection({
  onCheckout
}: OfferSectionProps) {
  const [selectedPlan, setSelectedPlan] = useState<'base' | 'mega'>('mega');
  const handleCheckout = () => {
    if (selectedPlan === 'mega') {
      window.location.href = CHECKOUT_MEGA;
    } else {
      onCheckout();
    }
  };
  return <section id="oferta" className="py-20 px-4 scroll-mt-20" data-id="element-93">
      <div className="max-w-4xl mx-auto" data-id="element-94">
        {/* Header */}
        <div className="bg-[#0B1D3A] p-8 text-center rounded-t-3xl border-b-4 border-[#00B4D8]" data-id="element-95">
          <div className="text-2xl font-mono font-bold text-[#E74C3C] mb-4 bg-white inline-block px-4 py-1 rounded-md" data-id="element-96">
            <CountdownTimer data-id="element-97" />
          </div>
          <h2 className="text-3xl font-bold text-white" data-id="element-98">
            Todo lo que recibís hoy:
          </h2>
        </div>

        {/* Value stack (shared) */}
        <div className="bg-gray-50 p-8 md:p-12" data-id="element-99">
          <ul className="space-y-4 mb-8" data-id="element-100">
            {[{
            name: 'InfoSkills Pro — 33 Skills de IA (5 módulos)',
            value: '$49.900'
          }, {
            name: 'BONO 1: Proyecto Pre-Armado',
            value: '$9.900'
          }, {
            name: 'BONO 2: Swipe File de 50 Hooks',
            value: '$7.900'
          }, {
            name: 'BONO 3: Matriz de Diversificación Creativa',
            value: '$6.900'
          }, {
            name: 'BONO 4: Checklist de Lanzamiento 14 Días',
            value: '$4.900'
          }].map((item, index) => <li key={index} className="flex items-center justify-between text-gray-800 font-medium" data-id="element-101">
                <div className="flex items-center gap-3" data-id="element-102">
                  <Check className="w-5 h-5 text-[#27AE60] flex-shrink-0" data-id="element-103" />
                  <span data-id="element-104">{item.name}</span>
                </div>
                <div className="flex-1 border-b-2 border-dotted border-gray-300 mx-4 hidden md:block" data-id="element-105"></div>
                <span className="text-gray-500 whitespace-nowrap" data-id="element-106">
                  Valor: {item.value}
                </span>
              </li>)}
          </ul>
        </div>

        {/* Plan selector */}
        <div className="bg-white px-6 md:px-12 pb-10" data-id="element-107">
          <h3 className="text-2xl font-bold text-gray-800 text-center pt-8 mb-8" data-id="element-108">
            Elegí tu plan:
          </h3>

          <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-10" data-id="element-109">
            {/* Base Plan */}
            <div onClick={() => setSelectedPlan('base')} className={`relative cursor-pointer rounded-2xl border-2 p-6 transition-all ${selectedPlan === 'base' ? 'border-[#27AE60] bg-[#27AE60]/5 shadow-lg' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-110">
              <div className="flex items-center gap-3 mb-4" data-id="element-111">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'base' ? 'border-[#27AE60]' : 'border-gray-300'}`} data-id="element-112">
                  {selectedPlan === 'base' && <div className="w-3 h-3 rounded-full bg-[#27AE60]" data-id="element-113" />}
                </div>
                <Star className="w-6 h-6 text-[#27AE60]" data-id="element-114" />
                <h4 className="text-xl font-bold text-gray-800" data-id="element-115">
                  InfoSkills Pro
                </h4>
              </div>

              <div className="space-y-2 mb-6" data-id="element-116">
                <p className="text-gray-500" data-id="element-117">Valor total: $79.500</p>
                <p className="text-gray-500" data-id="element-118">
                  Precio anterior: <span className="line-through" data-id="element-119">$30.990</span>
                </p>
              </div>

              <div className="flex items-baseline gap-2 mb-2" data-id="element-120">
                <span className="text-4xl font-extrabold text-[#27AE60]" data-id="element-121">
                  $19.800
                </span>
              </div>
              <p className="text-[#E74C3C] font-bold text-sm" data-id="element-122">
                Ahorro del 75% + 4 bonos gratis
              </p>
            </div>

            {/* Mega Pack */}
            <div onClick={() => setSelectedPlan('mega')} className={`relative cursor-pointer rounded-2xl border-2 p-6 transition-all ${selectedPlan === 'mega' ? 'border-[#00B4D8] bg-[#00B4D8]/5 shadow-lg ring-2 ring-[#00B4D8]/30' : 'border-gray-200 hover:border-gray-300'}`} data-id="element-123">
              <div className="absolute -top-3 right-4 bg-[#E74C3C] text-white text-xs font-bold py-1 px-3 rounded-full shadow-md" data-id="element-124">
                ⭐ MÁS POPULAR
              </div>

              <div className="flex items-center gap-3 mb-4" data-id="element-125">
                <div className={`w-5 h-5 rounded-full border-2 flex items-center justify-center ${selectedPlan === 'mega' ? 'border-[#00B4D8]' : 'border-gray-300'}`} data-id="element-126">
                  {selectedPlan === 'mega' && <div className="w-3 h-3 rounded-full bg-[#00B4D8]" data-id="element-127" />}
                </div>
                <Crown className="w-6 h-6 text-[#00B4D8]" data-id="element-128" />
                <h4 className="text-xl font-bold text-gray-800" data-id="element-129">
                  InfoSkills Pro FULL
                </h4>
              </div>

              <p className="text-sm text-gray-600 mb-4 font-medium" data-id="element-130">
                Todo lo del pack base ($19.800) + 3 Masterclasses exclusivas:
              </p>

              <div className="space-y-3 mb-6" data-id="element-131">
                <div className="flex items-start gap-2" data-id="element-132">
                  <PlayCircle className="w-5 h-5 text-[#00B4D8] flex-shrink-0 mt-0.5" data-id="element-133" />
                  <div data-id="element-134">
                    <p className="text-gray-800 font-medium text-sm" data-id="element-135">
                      "Cómo Crear tu Ebook con IA" (45-60 min)
                    </p>
                    <p className="text-gray-500 text-xs" data-id="element-136">
                      El proceso completo de cero a ebook terminado usando las
                      skills. Valor: $19.900
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2" data-id="element-137">
                  <PlayCircle className="w-5 h-5 text-[#00B4D8] flex-shrink-0 mt-0.5" data-id="element-138" />
                  <div data-id="element-139">
                    <p className="text-gray-800 font-medium text-sm" data-id="element-140">
                      "Diseño con Gamma" (30-40 min)
                    </p>
                    <p className="text-gray-500 text-xs" data-id="element-141">
                      Diseñar un ebook profesional sin saber diseño, en vivo.
                      Valor: $14.900
                    </p>
                  </div>
                </div>
                <div className="flex items-start gap-2" data-id="element-142">
                  <PlayCircle className="w-5 h-5 text-[#00B4D8] flex-shrink-0 mt-0.5" data-id="element-143" />
                  <div data-id="element-144">
                    <p className="text-gray-800 font-medium text-sm" data-id="element-145">
                      "Análisis en Biblioteca de Anuncios" (30-40 min)
                    </p>
                    <p className="text-gray-500 text-xs" data-id="element-146">
                      Espiar competencia y crear ángulos propios. Valor: $14.900
                    </p>
                  </div>
                </div>
              </div>

              <div className="space-y-1 mb-4" data-id="element-147">
                <p className="text-gray-500 text-sm" data-id="element-148">
                  Value stack total: $129.200
                </p>
                <p className="text-gray-500 text-sm" data-id="element-149">
                  Precio anterior: <span className="line-through" data-id="element-150">$69.990</span>
                </p>
              </div>

              <div className="flex items-baseline gap-2 mb-2" data-id="element-151">
                <span className="text-4xl font-extrabold text-[#00B4D8]" data-id="element-152">
                  $39.800
                </span>
              </div>
              <p className="text-[#E74C3C] font-bold text-sm" data-id="element-153">
                Ahorro del 69% + 4 bonos + 3 masterclasses
              </p>
            </div>
          </div>

          {/* CTA Button */}
          <div className="flex flex-col items-center" data-id="element-154">
            <button onClick={handleCheckout} className="w-full bg-[#E74C3C] hover:bg-[#c0392b] text-white text-xl md:text-2xl font-bold py-6 px-8 rounded-xl shadow-[0_10px_20px_rgba(231,76,60,0.3)] hover:shadow-[0_15px_30px_rgba(231,76,60,0.4)] transition-all transform hover:-translate-y-1 text-center" data-id="element-155">
              {selectedPlan === 'mega' ? 'ACCEDER AL MEGA PACK COMPLETO — $39.800' : 'ACCEDER AHORA A INFOSKILLS PRO — $19.800'}
            </button>
            <p className="text-gray-500 mt-4 text-sm font-medium" data-id="element-156">
              Pago único. Sin suscripción. Tuyo para siempre. Descarga
              inmediata.
            </p>
          </div>
        </div>

        {/* Trust bar */}
        <div className="bg-gray-100 p-6 rounded-b-3xl border-t border-gray-200" data-id="element-157">
          <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-600 font-medium" data-id="element-158">
            <div className="flex items-center gap-2" data-id="element-159">
              <Lock className="w-4 h-4" data-id="element-160" /> Pago seguro
            </div>
            <div className="flex items-center gap-2" data-id="element-161">
              <Shield className="w-4 h-4" data-id="element-162" /> Garantía 45 días
            </div>
            <div className="flex items-center gap-2" data-id="element-163">
              <Download className="w-4 h-4" data-id="element-164" /> Descarga inmediata
            </div>
            <div className="flex items-center gap-2" data-id="element-165">
              <Lock className="w-4 h-4" data-id="element-166" /> Protección de datos
            </div>
            <div className="flex items-center gap-2" data-id="element-167">
              <CreditCard className="w-4 h-4" data-id="element-168" /> Visa, Mastercard, Amex, Mercado
              Pago
            </div>
            <div className="flex items-center gap-2" data-id="element-169">
              <HeadphonesIcon className="w-4 h-4" data-id="element-170" /> Soporte
            </div>
          </div>
        </div>
      </div>
    </section>;
}